<ng-container *ngrxLet="selectActiveOrganization$; let activeOrganization">
  <ng-container *ngrxLet="selectUser$; let selectUser">
    <ng-container *ngrxLet="selectIsPanicAllowed$; let isPanicAllowed">
    <ng-container
      *ngrxLet="selectIsControlCenterAllowed$; let isControlCenterAllowed"
    >
      <div [dir]="directionality.value" class="sidebar-v2 flex-row h-100 w-100">
        <div
          [class.rtl]="directionality.value === 'rtl'"
          class="menu-level1 flex-col space-between-center"
        >
          <div class="flex-col">
            <img
              alt="logo"
              class="lumix-logo invert-on-white"
              src="assets/icons/logo.svg"
            />

            @if (isControlCenterAllowed || isPanicAllowed) {
              <div
                class="menu-item"
                [matTooltip]="'SIDEBAR.APPS' | translate"
                matTooltipClass="sidebar-tooltip"
                matTooltipPosition="right"
                [matTooltipDisabled]="appsMenuDropdown.isOpen"
              >
                <app-ui-dropdown #appsMenuDropdown [height]="appsMenuHeight">
                  <a class="menu-item flex-row center-center w-100" input>
                    <span class="ui-icon-apps-sidebar icon"></span>
                  </a>

                  <ng-template #contentTemplate>
                    @if (activeOrganization) {
                      <app-apps-menu
                        [appId]="appId"
                        [dropdown]="appsMenuDropdown"
                        [isControlCenterAllowed]="isControlCenterAllowed"
                        [isPanicAllowed]="isPanicAllowed"
                        [orgId]="activeOrganization.orgId"
                        [webUrl]="webUrl"
                        [controlCenterUrl]="controlCenterUrl"
                        [parkingUrl]="parkingUrl"
                        [sitePlannerUrl]="sitePlannerUrl"
                        [panicUrl]="panicUrl"
                        (switchApp)="switchApp($event)"
                        #appsMenu
                      ></app-apps-menu>
                    }
                  </ng-template>
                </app-ui-dropdown>
              </div>
            }
            <hr class="hr" style="margin: 8px 24px" />
            <!--    MENU ITEMS-->
            <ng-container *ngFor="let item of mainMenuItems">
            <ng-container *ngrxLet="selectEnableSidebarVideoTooltips$; let enableSidebarVideoTooltips">
            <div
              [matTooltip]="getMainMenuItemTooltip(item)"
              [matTooltipDisabled]="!!(item.videoUrl && enableSidebarVideoTooltips)"
              class="menu-item"
              matTooltipClass="sidebar-tooltip"
              matTooltipPosition="right"
            >
              @if (item?.separator) {
                <div class="separator"></div>
              }
              <ng-container *ngrxLet="selectActiveOrganization$; let org">
                @if (!!item.href) {
                  <a
                    *rbacAllow="item.roles"
                    [href]="item.disabled || item.path ? null : item.href"
                    routerLinkActive="active"
                    [target]="item.href ? '_blanc' : null"
                    class="flex-row"
                    [class.active]="
                      activeState && item.path === routerSegments.locationV2
                    "
                    matRipple
                    matRippleColor="rgba(67, 103, 246, 0.1)"
                  >
                    <span
                      *ngIf="!!item.class"
                      [class]="item.class"
                      class="icon"
                    ></span>
                    <mat-icon
                      *ngIf="!!item?.svg"
                      [svgIcon]="item.svg"
                      class="icon"
                    ></mat-icon>
                    <mat-icon *ngIf="!!item?.icon" class="icon">{{
                      item.icon
                    }}</mat-icon>
                  </a>
                } @else {
                  @if (
                    item.path === routerSegments.alertsV2 &&
                    isControlCenterAllowed
                  ) {
                    <app-ui-dropdown #alertsMenuDropdown [height]="320">
                      <a
                        *rbacAllow="item.roles; orgIds: item.orgIds"
                        class="flex-row w-100"
                        [class.active]="
                          router.url.includes('/' + routerSegments.alertsV2) ||
                          router.url.includes('/' + routerSegments.monitoring) ||
                          router.url.includes('/' + routerSegments.monitoringV3)
                        "
                        matRipple
                        matRippleColor="rgba(67, 103, 246, 0.1)"
                        input
                      >
                        <span
                          *ngIf="!!item.class"
                          [class]="item.class"
                          class="icon"
                        ></span>
                        <mat-icon
                          *ngIf="!!item?.svg"
                          [svgIcon]="item.svg"
                          class="icon"
                        ></mat-icon>
                        <mat-icon *ngIf="!!item?.icon" class="icon">{{
                          item.icon
                        }}</mat-icon>
                      </a>

                      <ng-template #contentTemplate>
                        <div class="user-menu alerts-menu">
                          <div class="user-menu-inner flex-col">
                            <div
                              *rbacOrgAllow="[permissions.AlertMonitoring]"
                              class="flex-row start-center menu-item clickable"
                              (click)="
                                navigateAlertsMenu(
                                  selectUseAlertsV3PageSig() ? alertsPages.monitoringV3 : alertsPages.monitoring,
                                  alertsMenuDropdown
                                )
                              "
                            >
                              {{
                                'ALERTS_DROPDOWN.ALERTS_MONITORING' | translate
                              }}
                            </div>
                            <div
                              *rbacOrgAllow="[permissions.EventCreate]"
                              class="flex-row start-center menu-item clickable"
                              (click)="
                                navigateAlertsMenu(
                                  alertsPages.create,
                                  alertsMenuDropdown
                                )
                              "
                            >
                              {{ 'ALERTS_DROPDOWN.CREATE_ALERT' | translate }}
                            </div>
                            <div
                              *rbacOrgAllow="[permissions.EventRead]"
                              class="flex-row start-center menu-item clickable"
                              (click)="
                                navigateAlertsMenu(
                                  alertsPages.configuration,
                                  alertsMenuDropdown
                                )
                              "
                            >
                              {{
                                'ALERTS_DROPDOWN.ALERTS_CONFIGURATION'
                                  | translate
                              }}
                            </div>
                            <div
                              *rbacOrgAllow="[permissions.AlertGroups]"
                              class="flex-row start-center menu-item clickable"
                              (click)="
                                navigateAlertsMenu(
                                  alertsPages.groups,
                                  alertsMenuDropdown
                                )
                              "
                            >
                              {{ 'ALERTS_DROPDOWN.ALERTS_GROUPS' | translate }}
                            </div>

                            @if (isControlCenterAllowed) {
                              <hr class="hr" />

                              <div
                                class="flex-row start-center menu-item clickable"
                                (click)="
                                  navigateAlertsMenu(
                                    alertsPages.zones,
                                    alertsMenuDropdown
                                  )
                                "
                              >
                                {{ 'ALERTS_DROPDOWN.ACCOUNTS' | translate }}
                              </div>
                              <div
                                class="flex-row start-center menu-item clickable"
                                (click)="
                                  navigateAlertsMenu(
                                    alertsPages.zoneMonitoring,
                                    alertsMenuDropdown
                                  )
                                "
                              >
                                {{
                                  'ALERTS_DROPDOWN.ACCOUNT_MONITORING'
                                    | translate
                                }}
                              </div>
                            }
                          </div>
                        </div>
                      </ng-template>
                    </app-ui-dropdown>
                  } @else if (item.path === routerSegments.chat) {
                    <a
                      *rbacAllow="item.roles; orgIds: item.orgIds"
                      [routerLink]="
                        item.disabled || item.href ? null : '/' + item.path
                      "
                      routerLinkActive="active"
                      [target]="item.href ? '_blanc' : null"
                      class="flex-row sidebar-menu-item-chat-link"
                      [class.active]="
                        activeState && item.path === routerSegments.locationV2
                      "
                      matRipple
                      matRippleColor="rgba(67, 103, 246, 0.1)"
                    >
                      <span class="sidebar-menu-item-chat-icon-wrap">
                        <span
                          *ngIf="!!item.class"
                          [class]="item.class"
                          class="icon"
                        ></span>
                        @if (
                          matrixChatSidebarUnreadBadgeAllowed() &&
                          chatSidebarUnreadTotal() > 0
                        ) {
                          <span
                            class="sidebar-chat-unread-badge"
                            [attr.aria-label]="
                              chatSidebarUnreadBadgeAriaLabel()
                            "
                            >{{ chatSidebarUnreadBadgeText() }}</span
                          >
                        }
                      </span>
                    </a>
                  } @else {
                    <a
                      *rbacAllow="item.roles; orgIds: item.orgIds"
                      [routerLink]="
                        item.disabled || item.href ? null : '/' + item.path
                      "
                      routerLinkActive="active"
                      [target]="item.href ? '_blanc' : null"
                      class="flex-row"
                      [class.active]="
                        activeState && item.path === routerSegments.locationV2
                      "
                      matRipple
                      matRippleColor="rgba(67, 103, 246, 0.1)"
                    >
                      <span
                        *ngIf="!!item.class"
                        [class]="item.class"
                        class="icon"
                      ></span>
                      <mat-icon
                        *ngIf="!!item?.svg"
                        [svgIcon]="item.svg"
                        class="icon"
                      ></mat-icon>
                      <mat-icon *ngIf="!!item?.icon" class="icon">{{
                        item.icon
                      }}</mat-icon>
                    </a>
                  }
                }
                @if (item.videoUrl && enableSidebarVideoTooltips) {
                  <span class="menu-item-video-link">
                    {{ item.displayName | translate }} ·
                    <a
                      [href]="item.videoUrl"
                      target="_blank"
                      (click)="$event.stopPropagation()"
                      >{{ 'MAIN_MENU.WATCH_VIDEO' | translate }}</a
                    >
                  </span>
                }
              </ng-container>
            </div>
            </ng-container>
            </ng-container>
            <ng-container *ngrxLet="selectActiveOrganization$; let org">
              <ng-container *rbacOrgAllow="[permissions.PortalManagement]">
                @let menuItem =
                  org?.isPartner ? partnerMenuItem : managementMenuItem;
                <div
                  [matTooltip]="menuItem.displayName | translate"
                  class="menu-item"
                  matTooltipClass="sidebar-tooltip"
                  matTooltipPosition="right"
                >
                  <a
                    *rbacAllow="menuItem.roles; orgIds: menuItem.orgIds"
                    [class.active]="
                      activeState && menuItem.path === routerSegments.locationV2
                    "
                    [routerLink]="
                      menuItem.disabled || menuItem.href
                        ? null
                        : '/' + menuItem.path
                    "
                    [target]="menuItem.href ? '_blanc' : null"
                    class="flex-row"
                    matRipple
                    matRippleColor="rgba(67, 103, 246, 0.1)"
                    routerLinkActive="active"
                  >
                    <span
                      *ngIf="!!menuItem.class"
                      [class]="menuItem.class"
                      class="icon"
                    ></span>
                    <mat-icon
                      *ngIf="!!menuItem?.svg"
                      [svgIcon]="menuItem.svg"
                      class="icon"
                    ></mat-icon>
                    <mat-icon *ngIf="!!menuItem?.icon" class="icon">{{
                      menuItem.icon
                    }}</mat-icon>
                  </a>
                </div>
              </ng-container>
              <ng-container *ngrxLet="selectIntegrations$; let integrations">
                @if (
                  integrations?.includes(IntegrationProviders.Lumana) ||
                  integrations?.includes(IntegrationProviders.NoonLight)
                ) {
                  <ng-container *rbacOrgAllow="[permissions.CallCenter]">
                    <hr class="hr" />
                    <div
                      [matTooltip]="'ALERTS_DROPDOWN.CALL_CENTER' | translate"
                      class="menu-item"
                      matTooltipClass="sidebar-tooltip"
                      matTooltipPosition="right"
                    >
                      <a
                        class="flex-row start-center menu-item clickable w-100"
                        [routerLink]="routerSegments.alarmManagement"
                        routerLinkActive="active"
                      >
                        <span class="ui-icon-help-center-sidebar icon"></span>
                      </a>
                    </div>
                  </ng-container>
                }
              </ng-container>
            </ng-container>

            <div *ngIf="swUpdateAvailable" class="sw-update-window flex-col">
              <div class="flex-row start-center gap-12">
                <div class="icon-16 svg-fill-red flex-row center-center">
                  <mat-icon svgIcon="info"></mat-icon>
                </div>
                <div class="title">
                  {{
                    swUpdateTrial
                      ? ('SIDEBAR.UPDATE_FAILED' | translate)
                      : ('SIDEBAR.UPDATE_REQUIRED' | translate)
                  }}
                </div>
              </div>
              <ng-container *ngIf="!swUpdateTrial; else failed">
                <div class="description">
                  {{ 'SIDEBAR.UPDATE_DESCRIPTION' | translate }}
                </div>
                <div class="flex-row start-center gap-8">
                  <ui-button
                    (clickAction)="reloadPage()"
                    [text]="'SIDEBAR.UPDATE_BUTTON_TEXT' | translate"
                    type="primary"
                  ></ui-button>
                </div>
              </ng-container>
              <ng-template #failed>
                <div class="description">
                  {{ 'SIDEBAR.MANUAL_UPDATE_DESCRIPTION' | translate }}
                </div>
                <div class="flex-col start-start gap-8 w-100">
                  <div>Mac</div>
                  <input
                    class="ui-input ui-input-40 w-100"
                    disabled
                    placeholder="Cmd + Shift + R"
                  />
                </div>
                <div class="flex-col start-start gap-8 w-100">
                  <div>Windows</div>
                  <input
                    class="ui-input ui-input-40 w-100"
                    disabled
                    placeholder="Ctrl + F5"
                  />
                </div>
              </ng-template>
            </div>
          </div>
          <!--        BOTTOM MENU-->
          <div
            *ngrxLet="isDeveloper$; let isDeveloper"
            class="bottom-menu flex-col start-start"
          >
            <div
              *ifMagentrix
              [class.active]="isHelpSection"
              [matTooltip]="'MAIN_MENU.MONITORING_PORTAL' | translate"
              class="help-icon-wrapper flex-row center-center"
              matTooltipClass="sidebar-tooltip"
              matTooltipPosition="right"
            >
              <span
                class="help-icon ui-icon-cat-safety icon"
                (click)="magentrixLogin()"
              ></span>
            </div>
            <div
              [class.active]="isHelpSection"
              [matTooltip]="'SIDEBAR.HELP_TOOLTIP' | translate"
              class="help-icon-wrapper flex-row center-center"
              matTooltipClass="sidebar-tooltip"
              matTooltipPosition="right"
            >
              <app-ui-dropdown
                #supportMenuDropdown
                [height]="supportMenuHeight"
              >
                <div class="flex-row center-center w-100" input>
                  <span class="help-icon ui-icon-help-sidebar icon"></span>
                </div>

                <ng-template #contentTemplate>
                  <div #supportMenu class="user-menu support">
                    <div class="user-menu-inner flex-col">
                      @if (!(selectHideSupportButtons$ | async)) {
                        <div class="menu-title support">
                          {{ 'SIDEBAR.SUPPORT_MENU.TITLE' | translate }}
                        </div>
                        <div class="flex-row start-center gap-4">
                          <span
                            class="validation-dot"
                            style="
                              width: 8px;
                              height: 8px;
                              border-radius: 50%;
                              background-color: #22c55e;
                            "
                          ></span>
                          <div class="menu-title support-bottom">
                            {{ 'SIDEBAR.SUPPORT_MENU.AVAILABLE' | translate }}
                          </div>
                        </div>
                        <hr class="hr" />
                        <!-- Live chat -->
                        <div
                          (click)="
                            openZendeskChat();
                            supportMenuDropdown.toggleDropdown()
                          "
                          class="flex-row start-center menu-item clickable"
                        >
                          <div class="flex-row start-center gap-8">
                            <span class="icon ui-icon-comment"></span>
                            <span class="link-text">{{
                              'SIDEBAR.SUPPORT_MENU.LIVE_CHAT' | translate
                            }}</span>
                          </div>
                        </div>

                        <!-- Email -->
                        <a
                          (click)="openSupportEmail($event, supportMenuDropdown)"
                          class="flex-row start-center menu-item clickable"
                        >
                          <div class="flex-row start-center gap-8">
                            <span class="icon ui-icon-mail"></span>
                            <span class="link-text">{{
                              'SIDEBAR.SUPPORT_MENU.EMAIL' | translate
                            }}</span>
                          </div>
                        </a>
                        <div
                          (click)="openSupportAccess(supportMenuDropdown)"
                          class="flex-row start-center menu-item clickable"
                        >
                          <div class="flex-row start-center gap-8">
                            <span class="icon ui-icon-wrench"></span>
                            <span class="link-text">{{ 'SIDEBAR.SUPPORT_MENU.SUPPORT_ACCESS' | translate }}</span>
                          </div>
                        </div>

                        <!-- Phone - North America -->
                        <div class="menu-item">
                          <div class="flex-row start-center gap-8">
                            <span class="icon ui-icon-phone"></span>
                            <div class="flex-row start-center gap-8">
                              <span class="region-text">{{
                                'SIDEBAR.SUPPORT_MENU.PHONE_NORTH_AMERICA'
                                  | translate
                              }}</span>
                              <a href="tel:+18004705576" class="link-text">{{
                                'SIDEBAR.SUPPORT_MENU.PHONE_NORTH_AMERICA_NUMBER'
                                  | translate
                              }}</a>
                            </div>
                          </div>
                        </div>

                        <!-- Phone - Israel -->
                        <div class="menu-item">
                          <div class="flex-row start-center gap-8">
                            <span class="icon ui-icon-phone"></span>
                            <div class="flex-row start-center gap-8">
                              <span class="region-text">{{
                                'SIDEBAR.SUPPORT_MENU.PHONE_ISRAEL' | translate
                              }}</span>
                              <a href="tel:+97233824445" class="link-text">{{
                                'SIDEBAR.SUPPORT_MENU.PHONE_ISRAEL_NUMBER'
                                  | translate
                              }}</a>
                            </div>
                          </div>
                        </div>

                        <hr class="hr" />
                        <!-- Support tickets -->
                        <div
                          (click)="about(undefined, supportMenuDropdown)"
                          class="flex-row start-center menu-item clickable"
                        >
                          <div class="flex-row start-center gap-8">
                            <span class="icon ui-icon-chat"></span>
                            <span class="link-text">{{
                                'SIDEBAR.SUPPORT_MENU.SUPPORT_CENTER' | translate
                              }}</span>
                            <span class="icon ui-icon-new-tab opacity-50"></span>
                          </div>
                        </div>
                      }
                      <!-- Help Center (GitBook) -->
                      <div
                        (click)="openHelpCenter(supportMenuDropdown)"
                        class="flex-row start-center menu-item clickable"
                      >
                        <div class="flex-row start-center gap-8">
                          <span class="icon ui-icon-book"></span>
                          <span class="link-text">{{
                            'SIDEBAR.SUPPORT_MENU.HELP_CENTER' | translate
                          }}</span>
                          <span class="icon ui-icon-new-tab opacity-50"></span>
                        </div>
                      </div>

                    </div>
                  </div>
                </ng-template>
              </app-ui-dropdown>
            </div>
            <div
              [matTooltip]="'SIDEBAR.USER_TOOLTIP' | translate"
              class="user-icon-wrapper flex-row center-center"
              matTooltipClass="sidebar-tooltip"
              matTooltipPosition="right"
            >
              <!--            USER SUB MENU-->
              <app-ui-dropdown #userMenuDropdown [height]="userMenuHeight">
                <div class="flex-row center-center w-100" input>
                  <span class="user-icon icon ui-icon-user-sidebar"></span>
                </div>

                <ng-template #contentTemplate>
                  <div #userMenu class="user-menu">
                    <div class="user-menu-inner flex-col">
                      <ng-container *ngIf="selectUser">
                        <div class="menu-title">
                          {{ selectUser.firstname }} {{ selectUser.lastname }}
                        </div>
                        <div class="menu-title truncated-user">
                          {{ selectUser.email }}
                        </div>
                      </ng-container>
                      <hr class="hr" />
                      <div
                        (click)="userMenuDropdown.toggleDropdown()"
                        [routerLink]="routerSegments.account"
                        class="flex-row start-center menu-item"
                      >
                        <div class="flex-row start-center gap-8">
                          <span class="icon ui-icon-settings"></span>
                          <span>{{
                            'SIDEBAR.USER_MENU.SETTINGS' | translate
                          }}</span>
                        </div>
                      </div>
                      <div
                        (click)="userMenuDropdown.toggleDropdown()"
                        *ifDeveloper
                        [routerLink]="routerSegments.adminSettings"
                        class="menu-item"
                      >
                        <div class="flex-row start-center gap-8">
                          <span class="icon ui-icon-settings"></span>
                          <span>{{
                            'SIDEBAR.ORG_MENU.ADMIN_SETTINGS' | translate
                          }}</span>
                        </div>
                      </div>
                      <div
                        (click)="userMenuDropdown.toggleDropdown()"
                        *ifOperator
                        [routerLink]="routerSegments.operatorSettings"
                        class="menu-item"
                      >
                        <div class="flex-row start-center gap-8">
                          <span class="icon ui-icon-settings"></span>
                          <span>{{
                            'SIDEBAR.ORG_MENU.OPERATOR_SETTINGS' | translate
                          }}</span>
                        </div>
                      </div>
                      <div
                        (click)="logout(); userMenuDropdown.toggleDropdown()"
                        class="menu-item logout-button flex-row space-between-center"
                      >
                        <div class="flex-row start-center gap-8">
                          <span class="icon ui-icon-logout"></span>
                          <span>{{
                            'SIDEBAR.USER_MENU.LOGOUT' | translate
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </app-ui-dropdown>
            </div>

            <!--      ORG SUB MENU-->

            <div
              [matTooltip]="'SIDEBAR.ORG_TOOLTIP' | translate"
              class="active-organization w-100"
              matTooltipClass="sidebar-tooltip"
              matTooltipPosition="right"
              [matTooltipDisabled]="orgMenuDropdown.isOpen || isOrgSelectorOpen"
            >
              <div class="w-100" style="padding: 8px 0">
                <app-ui-dropdown #orgMenuDropdown [height]="orgMenuHeight">
                  <div class="flex-row center-center w-100" input>
                    <ui-avatar
                      [color]="activeOrganization?.orgColor"
                      [name]="activeOrganization?.orgName"
                      class="org-avatar"
                    ></ui-avatar>
                  </div>

                  <ng-template #contentTemplate>
                    <div #orgMenu class="user-menu">
                      <div class="user-menu-inner flex-col">
                        <div class="menu-title">
                          <ui-truncated-html class="truncated-name">
                            {{ activeOrganization?.orgName }}
                          </ui-truncated-html>
                        </div>
                        <hr class="hr" />
                        <div class="menu-item">
                          <div
                            (click)="
                              toggleSwitchOrgMenu();
                              orgMenuDropdown.toggleDropdown()
                            "
                            class="flex-row start-center gap-8"
                          >
                            <span class="icon ui-icon-company"></span>
                            <span>{{
                              'SIDEBAR.ORG_MENU.SWITCH_ORG' | translate
                            }}</span>
                          </div>
                        </div>
                        <div
                          (click)="orgMenuDropdown.toggleDropdown()"
                          *rbacOrgAllow="[permissions.OrganizationDatabase]"
                          [routerLink]="routerSegments.database"
                          class="menu-item"
                        >
                          <div class="flex-row start-center gap-8">
                            <span class="icon ui-icon-dashboard"></span>
                            <span>{{
                              'SIDEBAR.ORG_MENU.DATABASE' | translate
                            }}</span>
                          </div>
                        </div>
                        <!--                      <ng-container *ngrxLet="selectActiveOrganization$; let org">-->
                        <!--                        <div (click)="orgMenuDropdown.toggleDropdown()" *ngIf="org?.isPartner"-->
                        <!--                             [routerLink]="routerSegments.partnerPortal"-->
                        <!--                             class="flex-row start-center menu-item">-->
                        <!--                          <div class="flex-row start-center gap-8">-->
                        <!--                            <span class="icon ui-icon-dashboards"></span>-->
                        <!--                            <span>{{ 'SIDEBAR.USER_MENU.PARTNER_PORTAL' | translate }}</span>-->
                        <!--                          </div>-->
                        <!--                        </div>-->
                        <!--                      </ng-container>-->
                        <div
                          (click)="orgMenuDropdown.toggleDropdown()"
                          [routerLink]="routerSegments.settings"
                          class="menu-item"
                        >
                          <div class="flex-row start-center gap-8">
                            <span class="icon ui-icon-settings"></span>
                            <span>{{
                              'SIDEBAR.ORG_MENU.SETTINGS' | translate
                            }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </app-ui-dropdown>
              </div>
            </div>
          </div>
        </div>
        <!--      SELECT ORGANIZATION -->
        <ng-container>
          <app-switch-organization
            (onMenuClosed)="closeSwitchOrgMenu()"
            *ngIf="isOrgSelectorOpen"
            [activeOrganization]="activeOrganization"
            [position]="directionality.value === 'ltr' ? 'left' : 'right'"
            [userOrganizations]="selectUserOrganizationsDropdown$ | async"
          ></app-switch-organization>
        </ng-container>

        <!--    CONTENT OF ROUTES-->
        <div class="root-content-wrapper">
          <router-outlet></router-outlet>
        </div>
      </div>
    </ng-container>
    </ng-container>
  </ng-container>
</ng-container>
